/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  AdminCustomerEventImpactingEventsTableDataRetrieveParams
} from '../../model/adminCustomerEventImpactingEventsTableDataRetrieveParams'
import type {
  AdminCustomerEventTransactionTableDataRetrieveParams
} from '../../model/adminCustomerEventTransactionTableDataRetrieveParams'
import type {
  CustomerEventAPIData
} from '../../model/customerEventAPIData'
import type {
  CustomerEventCreateDataAPIData
} from '../../model/customerEventCreateDataAPIData'
import type {
  CustomerEventCreateDataAPIDataRequest
} from '../../model/customerEventCreateDataAPIDataRequest'
import type {
  GenericSelectDataList
} from '../../model/genericSelectDataList'
import type {
  GenericTableData
} from '../../model/genericTableData'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Gets a customer event create data
 */
export const customerEventRetrieve = (
    customerEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<CustomerEventAPIData>(
      {url: `/customer-event/${customerEventId}/`, method: 'GET', signal
    },
      options);
    }
  

export const getCustomerEventRetrieveQueryKey = (customerEventId: string,) => {
    return [`/customer-event/${customerEventId}/`] as const;
    }

    
export const getCustomerEventRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof customerEventRetrieve>>, TError = unknown>(customerEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customerEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomerEventRetrieveQueryKey(customerEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customerEventRetrieve>>> = ({ signal }) => customerEventRetrieve(customerEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customerEventRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CustomerEventRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof customerEventRetrieve>>>
export type CustomerEventRetrieveQueryError = unknown

export const useCustomerEventRetrieve = <TData = Awaited<ReturnType<typeof customerEventRetrieve>>, TError = unknown>(
 customerEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customerEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCustomerEventRetrieveQueryOptions(customerEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCustomerEventRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof customerEventRetrieve>>, TError = unknown>(customerEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customerEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomerEventRetrieveQueryKey(customerEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customerEventRetrieve>>> = ({ signal }) => customerEventRetrieve(customerEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof customerEventRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CustomerEventRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof customerEventRetrieve>>>
export type CustomerEventRetrieveSuspenseQueryError = unknown

export const useCustomerEventRetrieveSuspense = <TData = Awaited<ReturnType<typeof customerEventRetrieve>>, TError = unknown>(
 customerEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customerEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCustomerEventRetrieveSuspenseQueryOptions(customerEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCustomerEventRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ customerEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { customerEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (customerEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCustomerEventRetrieveQueryKey(customerEventId),
              queryFn: () => customerEventRetrieve(customerEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets a customer event create data
 */
export const customerEventJsonRecordDataRetrieve = (
    customerEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<CustomerEventCreateDataAPIData>(
      {url: `/customer-event/${customerEventId}/create-data`, method: 'GET', signal
    },
      options);
    }
  

export const getCustomerEventJsonRecordDataRetrieveQueryKey = (customerEventId: string,) => {
    return [`/customer-event/${customerEventId}/create-data`] as const;
    }

    
export const getCustomerEventJsonRecordDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof customerEventJsonRecordDataRetrieve>>, TError = unknown>(customerEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customerEventJsonRecordDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomerEventJsonRecordDataRetrieveQueryKey(customerEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customerEventJsonRecordDataRetrieve>>> = ({ signal }) => customerEventJsonRecordDataRetrieve(customerEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customerEventJsonRecordDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CustomerEventJsonRecordDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof customerEventJsonRecordDataRetrieve>>>
export type CustomerEventJsonRecordDataRetrieveQueryError = unknown

export const useCustomerEventJsonRecordDataRetrieve = <TData = Awaited<ReturnType<typeof customerEventJsonRecordDataRetrieve>>, TError = unknown>(
 customerEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customerEventJsonRecordDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCustomerEventJsonRecordDataRetrieveQueryOptions(customerEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCustomerEventJsonRecordDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof customerEventJsonRecordDataRetrieve>>, TError = unknown>(customerEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customerEventJsonRecordDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomerEventJsonRecordDataRetrieveQueryKey(customerEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customerEventJsonRecordDataRetrieve>>> = ({ signal }) => customerEventJsonRecordDataRetrieve(customerEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof customerEventJsonRecordDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CustomerEventJsonRecordDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof customerEventJsonRecordDataRetrieve>>>
export type CustomerEventJsonRecordDataRetrieveSuspenseQueryError = unknown

export const useCustomerEventJsonRecordDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof customerEventJsonRecordDataRetrieve>>, TError = unknown>(
 customerEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customerEventJsonRecordDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCustomerEventJsonRecordDataRetrieveSuspenseQueryOptions(customerEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCustomerEventJsonRecordDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ customerEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { customerEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (customerEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCustomerEventJsonRecordDataRetrieveQueryKey(customerEventId),
              queryFn: () => customerEventJsonRecordDataRetrieve(customerEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Edits a customer event create data
 */
export const customerEventJsonRecordDataUpdate = (
    customerEventId: string,
    customerEventCreateDataAPIDataRequest: CustomerEventCreateDataAPIDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/customer-event/${customerEventId}/create-data`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: customerEventCreateDataAPIDataRequest
    },
      options);
    }
  


export const getCustomerEventJsonRecordDataUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customerEventJsonRecordDataUpdate>>, TError,{customerEventId: string;data: CustomerEventCreateDataAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof customerEventJsonRecordDataUpdate>>, TError,{customerEventId: string;data: CustomerEventCreateDataAPIDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof customerEventJsonRecordDataUpdate>>, {customerEventId: string;data: CustomerEventCreateDataAPIDataRequest}> = (props) => {
          const {customerEventId,data} = props ?? {};

          return  customerEventJsonRecordDataUpdate(customerEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CustomerEventJsonRecordDataUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof customerEventJsonRecordDataUpdate>>>
    export type CustomerEventJsonRecordDataUpdateMutationBody = CustomerEventCreateDataAPIDataRequest
    export type CustomerEventJsonRecordDataUpdateMutationError = unknown

    export const useCustomerEventJsonRecordDataUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customerEventJsonRecordDataUpdate>>, TError,{customerEventId: string;data: CustomerEventCreateDataAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCustomerEventJsonRecordDataUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets impacting event options for a customer event
 */
export const adminCustomerEventImpactingEventsOptionsRetrieve = (
    customerEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericSelectDataList>(
      {url: `/customer-event/${customerEventId}/impacting-events-select-data/`, method: 'GET', signal
    },
      options);
    }
  

export const getAdminCustomerEventImpactingEventsOptionsRetrieveQueryKey = (customerEventId: string,) => {
    return [`/customer-event/${customerEventId}/impacting-events-select-data/`] as const;
    }

    
export const getAdminCustomerEventImpactingEventsOptionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminCustomerEventImpactingEventsOptionsRetrieve>>, TError = unknown>(customerEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomerEventImpactingEventsOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCustomerEventImpactingEventsOptionsRetrieveQueryKey(customerEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCustomerEventImpactingEventsOptionsRetrieve>>> = ({ signal }) => adminCustomerEventImpactingEventsOptionsRetrieve(customerEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCustomerEventImpactingEventsOptionsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminCustomerEventImpactingEventsOptionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminCustomerEventImpactingEventsOptionsRetrieve>>>
export type AdminCustomerEventImpactingEventsOptionsRetrieveQueryError = unknown

export const useAdminCustomerEventImpactingEventsOptionsRetrieve = <TData = Awaited<ReturnType<typeof adminCustomerEventImpactingEventsOptionsRetrieve>>, TError = unknown>(
 customerEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomerEventImpactingEventsOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAdminCustomerEventImpactingEventsOptionsRetrieveQueryOptions(customerEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAdminCustomerEventImpactingEventsOptionsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof adminCustomerEventImpactingEventsOptionsRetrieve>>, TError = unknown>(customerEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminCustomerEventImpactingEventsOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCustomerEventImpactingEventsOptionsRetrieveQueryKey(customerEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCustomerEventImpactingEventsOptionsRetrieve>>> = ({ signal }) => adminCustomerEventImpactingEventsOptionsRetrieve(customerEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminCustomerEventImpactingEventsOptionsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminCustomerEventImpactingEventsOptionsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof adminCustomerEventImpactingEventsOptionsRetrieve>>>
export type AdminCustomerEventImpactingEventsOptionsRetrieveSuspenseQueryError = unknown

export const useAdminCustomerEventImpactingEventsOptionsRetrieveSuspense = <TData = Awaited<ReturnType<typeof adminCustomerEventImpactingEventsOptionsRetrieve>>, TError = unknown>(
 customerEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminCustomerEventImpactingEventsOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAdminCustomerEventImpactingEventsOptionsRetrieveSuspenseQueryOptions(customerEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getAdminCustomerEventImpactingEventsOptionsRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ customerEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { customerEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (customerEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getAdminCustomerEventImpactingEventsOptionsRetrieveQueryKey(customerEventId),
              queryFn: () => adminCustomerEventImpactingEventsOptionsRetrieve(customerEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets a table of impacting events for a customer event
 */
export const adminCustomerEventImpactingEventsTableDataRetrieve = (
    customerEventId: string,
    params?: AdminCustomerEventImpactingEventsTableDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/customer-event/${customerEventId}/impacting-events-table-data/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getAdminCustomerEventImpactingEventsTableDataRetrieveQueryKey = (customerEventId: string,
    params?: AdminCustomerEventImpactingEventsTableDataRetrieveParams,) => {
    return [`/customer-event/${customerEventId}/impacting-events-table-data/`, ...(params ? [params]: [])] as const;
    }

    
export const getAdminCustomerEventImpactingEventsTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminCustomerEventImpactingEventsTableDataRetrieve>>, TError = unknown>(customerEventId: string,
    params?: AdminCustomerEventImpactingEventsTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomerEventImpactingEventsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCustomerEventImpactingEventsTableDataRetrieveQueryKey(customerEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCustomerEventImpactingEventsTableDataRetrieve>>> = ({ signal }) => adminCustomerEventImpactingEventsTableDataRetrieve(customerEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCustomerEventImpactingEventsTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminCustomerEventImpactingEventsTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminCustomerEventImpactingEventsTableDataRetrieve>>>
export type AdminCustomerEventImpactingEventsTableDataRetrieveQueryError = unknown

export const useAdminCustomerEventImpactingEventsTableDataRetrieve = <TData = Awaited<ReturnType<typeof adminCustomerEventImpactingEventsTableDataRetrieve>>, TError = unknown>(
 customerEventId: string,
    params?: AdminCustomerEventImpactingEventsTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomerEventImpactingEventsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAdminCustomerEventImpactingEventsTableDataRetrieveQueryOptions(customerEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAdminCustomerEventImpactingEventsTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof adminCustomerEventImpactingEventsTableDataRetrieve>>, TError = unknown>(customerEventId: string,
    params?: AdminCustomerEventImpactingEventsTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminCustomerEventImpactingEventsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCustomerEventImpactingEventsTableDataRetrieveQueryKey(customerEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCustomerEventImpactingEventsTableDataRetrieve>>> = ({ signal }) => adminCustomerEventImpactingEventsTableDataRetrieve(customerEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminCustomerEventImpactingEventsTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminCustomerEventImpactingEventsTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof adminCustomerEventImpactingEventsTableDataRetrieve>>>
export type AdminCustomerEventImpactingEventsTableDataRetrieveSuspenseQueryError = unknown

export const useAdminCustomerEventImpactingEventsTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof adminCustomerEventImpactingEventsTableDataRetrieve>>, TError = unknown>(
 customerEventId: string,
    params?: AdminCustomerEventImpactingEventsTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminCustomerEventImpactingEventsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAdminCustomerEventImpactingEventsTableDataRetrieveSuspenseQueryOptions(customerEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getAdminCustomerEventImpactingEventsTableDataRetrieveLoader = (queryParamsOrFn?: (AdminCustomerEventImpactingEventsTableDataRetrieveParams | ((params: Params) => AdminCustomerEventImpactingEventsTableDataRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ customerEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { customerEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (customerEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getAdminCustomerEventImpactingEventsTableDataRetrieveQueryKey(customerEventId, queryParams),
              queryFn: () => adminCustomerEventImpactingEventsTableDataRetrieve(customerEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets a table of rolled up transactions for a customer event
 */
export const adminCustomerEventTransactionTableDataRetrieve = (
    customerEventId: string,
    params?: AdminCustomerEventTransactionTableDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/customer-event/${customerEventId}/transaction-table-data/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getAdminCustomerEventTransactionTableDataRetrieveQueryKey = (customerEventId: string,
    params?: AdminCustomerEventTransactionTableDataRetrieveParams,) => {
    return [`/customer-event/${customerEventId}/transaction-table-data/`, ...(params ? [params]: [])] as const;
    }

    
export const getAdminCustomerEventTransactionTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminCustomerEventTransactionTableDataRetrieve>>, TError = unknown>(customerEventId: string,
    params?: AdminCustomerEventTransactionTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomerEventTransactionTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCustomerEventTransactionTableDataRetrieveQueryKey(customerEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCustomerEventTransactionTableDataRetrieve>>> = ({ signal }) => adminCustomerEventTransactionTableDataRetrieve(customerEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCustomerEventTransactionTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminCustomerEventTransactionTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminCustomerEventTransactionTableDataRetrieve>>>
export type AdminCustomerEventTransactionTableDataRetrieveQueryError = unknown

export const useAdminCustomerEventTransactionTableDataRetrieve = <TData = Awaited<ReturnType<typeof adminCustomerEventTransactionTableDataRetrieve>>, TError = unknown>(
 customerEventId: string,
    params?: AdminCustomerEventTransactionTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomerEventTransactionTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAdminCustomerEventTransactionTableDataRetrieveQueryOptions(customerEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAdminCustomerEventTransactionTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof adminCustomerEventTransactionTableDataRetrieve>>, TError = unknown>(customerEventId: string,
    params?: AdminCustomerEventTransactionTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminCustomerEventTransactionTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCustomerEventTransactionTableDataRetrieveQueryKey(customerEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCustomerEventTransactionTableDataRetrieve>>> = ({ signal }) => adminCustomerEventTransactionTableDataRetrieve(customerEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminCustomerEventTransactionTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminCustomerEventTransactionTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof adminCustomerEventTransactionTableDataRetrieve>>>
export type AdminCustomerEventTransactionTableDataRetrieveSuspenseQueryError = unknown

export const useAdminCustomerEventTransactionTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof adminCustomerEventTransactionTableDataRetrieve>>, TError = unknown>(
 customerEventId: string,
    params?: AdminCustomerEventTransactionTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminCustomerEventTransactionTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAdminCustomerEventTransactionTableDataRetrieveSuspenseQueryOptions(customerEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getAdminCustomerEventTransactionTableDataRetrieveLoader = (queryParamsOrFn?: (AdminCustomerEventTransactionTableDataRetrieveParams | ((params: Params) => AdminCustomerEventTransactionTableDataRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ customerEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { customerEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (customerEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getAdminCustomerEventTransactionTableDataRetrieveQueryKey(customerEventId, queryParams),
              queryFn: () => adminCustomerEventTransactionTableDataRetrieve(customerEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      